import { Button, IconButton, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import { Layout, Loading, UserNavbar } from '../../../../../../components';
import { getEventsByVenue, getUserOwner } from './api/venue-transactions-actions';
import BasicTabs from './components/tabs';

export default function VenueTransactionsEventMM() {
  const [loading, setLoading] = useState(false);
  const [eventData, setEventData] = useState({});
  const [userOwner, setUserOwner] = useState({});

  const { venueId, eventId } = useParams();
  const navigate = useNavigate();

  const getData = async (venueIdParam, eventIdParam) => {
    setLoading(true);
    const responseEvent = await getEventsByVenue({
      id: eventIdParam || 0,
    });
    if (responseEvent && responseEvent.length > 0) {
      const localEventData = responseEvent[0];

      const ownerId = localEventData?.venue?.fk_user;
      if (ownerId) {
        const responseOwner = await getUserOwner(ownerId);
        if (responseOwner) setUserOwner(responseOwner);
      }
      setEventData(localEventData);
    }
    setLoading(false);
  };

  useEffect(() => {
    getData(venueId, eventId);
  }, [venueId, eventId]);

  return (
    <Layout>
      <UserNavbar />
      {loading && <Loading />}
      <Grid container justifyContent="center" marginTop={10}>
        <Grid item style={{ width: '100%' }}>
          <IconButton onClick={() => navigate(-1)}>
            <ArrowBackRoundedIcon />
          </IconButton>
        </Grid>
      </Grid>
      <Grid container justifyContent="center">
        <Grid item>
          <Typography variant="h3" color="#EE7B57" fontWeight="bold" marginTop={4}>
            Venue: {eventData?.venue?.name}, Event: {eventData?.name}
          </Typography>
        </Grid>
      </Grid>
      <Grid container justifyContent="center" marginTop={2}>
        <Grid item>
          <Button
            target="_blank"
            href={`https://dashboard.stripe.com/connect/accounts/${userOwner?.stripe_details?.stripe_account_id}/activity`}
            variant="contained"
            disabled={!userOwner?.stripe_details?.stripe_account_id}>
            See Stripe Account - {userOwner?.email}
          </Button>
        </Grid>
      </Grid>

      <Grid container justifyContent="center" padding={6}>
        <Grid size={12}>
          <h3>Money movement</h3>
          <BasicTabs userOwner={userOwner} />
        </Grid>
      </Grid>
    </Layout>
  );
}
